{
  "modal": {
    "header": "Mappé à"
  },
  "company_industry": "Industrie de l'entreprise",
  "choose_internal_industries": "Choisir les industries internes à mapper",
  "select_internal_industries_placeholder": "Sélectionner les industries internes",
  "page": {
    "description": "Mappez nos préférences d'industrie à votre liste d'industries internes personnalisée.",
    "internal_industry_button": "Industrie interne"
  },
  "table": {
    "headers": {
      "industry": "Secteur",
      "added_at": "Ajouté le",
      "mapped_to": "Mappé à",
      "actions": "Actions"
    }
  },
  "actions": {
    "map_tooltip": "Mapper",
    "view_companies_tooltip": "Voir les entreprises pour ce secteur",
    "mapped_to_button": "Mappé à"
  },
  "filters": {
    "unmapped_industry": "Secteur non mappé"
  }
}
